<template>
  <div id="support">

    <main>
      <div class="outer-wrapper">
        <h2>Contrology<sup>®</sup> Ped-o-Pul Support</h2>

        <support-nav />

        <link-list
          heading="Assembly Instructions"
          :links="instructions"
        />

        <video-link
          heading="Product Videos"
          :videos="videos"
        />

        <section class="accordion-wrapper">
          <p class="heading">Common Questions</p>
          <accordion title="Can I use the adjustable t-bar or bicycle seat from the KSG/CT Ped-o-Pul on the Contrology Ped-o-Pul?" animation="reveal">
            <p>The components of the KSG/CT Ped-o-Pul are not compatible with the Contrology Ped-o-Pul. The KSG/CT Ped-o-Pul has been pre-drilled to accommodate the adjustable crossbar and bicycle seat and the pole has a wider diameter than the Contrology pole.</p>
          </accordion>
          <accordion title="The pole on my Ped-o-Pul sways a little. Is there some way I can make it more secure?" animation="reveal">
            <p>The pole on the Contrology and KSG/CT Ped-o-Puls are intended to sway a little. The movement requires students and practitioners to work the stabilizing muscles to stabilize the pole.</p>
            <p>Perform regular safety and maintenance checks. Regularly inspect the screw attachments at the base to make sure they’re secure.</p>
          </accordion>
        </section>

        <p>Didn't find your answer? Please use the Contact Us link in the footer.</p>
      </div>
    </main>
  </div>
</template>

<script>
  import SupportNav from '@/components/SupportNav.vue';
  import LinkList from '@/components/LinkList.vue';
  import VideoLink from '@/components/VideoLink.vue';
  import Accordion from '@/components/Accordion.vue';

  export default {
    name: 'supportreformer',

    metaInfo: {
      title: "Contrology Ped O Pul User Guides - Ped O Pull - Balanced Body",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "Get your Contrology Ped O Pul Assembly, Use & Maintenance Guides here so you can enjoy the full benefit of your Pilates Ped O Pul."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-support.jpg"
        }
      ]
    },

     components: {
      SupportNav,
      LinkList,
      VideoLink,
      Accordion
    },

    data() {
      return {
        instructions: [
          {
            title: 'How to assemble your Contrology Ped-O-Pul (PDF)',
            url: 'https://s3.amazonaws.com/s3.pilates.com/resources/instructions/17189_howtoassemble_contrology_ped-o-pul_web.pdf'
          },
          {
            title: 'How to assemble your Contrology KSG/CT Ped-O-Pul (PDF)',
            url: 'https://s3.amazonaws.com/s3.pilates.com/resources/instructions/17147_howtoassemble_contrologyksg-ct ped-o-pul_web.pdf'
          }
        ],
        videos: [
          {
            title: 'How to Unbox and Assemble a Contrology® Ped-o-Pul',
            url: 'https://video.pilates.com/programs/contrologypedopul_unboxmp4-2dca85'
          }
        ]
      }
    }
  }
  
</script>

<style scoped lang="scss">
.outer-wrapper {
  max-width: 680px;
  margin: 0 auto;
}

.heading {
  font-family: var(--roboto);
  font-size: 1rem;
  line-height: 1.3125;
  font-weight: 700;
  color: var(--black);
  margin-bottom: 30px;
}

.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.resp-container {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
}

.accordion {
  cursor: pointer;
  border: none;
  text-align: left;
  outline: none;
  transition: 0.4s;
  border-top: 2px solid #010101;
  padding: 5px 0;
  position: relative;
  z-index: -1;
}

.accordion p {
  font-family: var(--roboto);
  font-weight: 700;
  font-size: .8125em;
  line-height: 1.308;
  color:  #333;
  max-width: 80%;
}

.accordion:before {
  content: '\02795';
  font-size: 1em;
  color: #333;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.accordion.active:before {
  content: "\2796";
}

.accordion-wrapper:last-of-type {
  border-bottom:  2px solid #010101;
  margin-bottom: 35px;
}

.panel {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.2s ease-out;
}

.panel p, ol, table, .panel a {
  font-family: var(--roboto);
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.308;
  color:  var(--black);
  max-width: 90%;
}

.panel ol {
  padding-left: 16px;
  padding-bottom: 10px;
}

.panel li {
  margin-bottom: 10px;
}

table {
  border: 1px solid var(--black);
  max-width: 100%;
  width: 100%;
  border-collapse:separate; 
  border-spacing:0 5px;
  margin-bottom: 20px;
}

thead tr th{
  border-bottom: 1px solid var(--black);
  padding: 5px;
}

td {
  width: 33%;
  padding: 5px;
}

.center {
  text-align: center;
}

@media only screen and (min-width: 1024px) {
  h2 {
    margin-bottom: 10px;
  }
}
</style>
